import React from "react";
import {FC} from "react";
import classNames from "classnames";
import {format} from "date-fns";
import {AppointmentDto} from "@apiModels/AppointmentDto.csharp";
import {SvgIcon} from "../../../SvgIcon/SvgIcon";

interface HourPickerItemProps {
    appointment: AppointmentDto;
    onSelect: (appointment: AppointmentDto) => void;
    active?: boolean;
}

export const HourPickerItem: FC<HourPickerItemProps> = ({
    appointment,
    onSelect,
    active
}) => {    
    return (
        <button
            className={classNames("HourPickerItem", {
                "HourPickerItem--active": active,
            })}
            onClick={() => onSelect(appointment)}
            type="button"
        >
            {format(appointment.startTime, "HH:mm")}
            {appointment.isRelatedAppointment && 
                <SvgIcon iconName="video" className="HourPickerItem__icon"/>
            }
        </button>
    );
}